/* @flow */

import { responseHasError } from '../diplomatico/reducers/helper';
import type { Action } from '../diplomatico/types';
import { enableInitializing } from 'initializable-reducer';

const initialState = [];

function schoolGeneralIntelligenceProgress(state: Array<Object> = initialState, { type, payload }: Action) {
  switch (type) {
    case 'RESPONSE_SCHOOL_GENERAL_INTELLIGENCE_PROGRESS':
      if (responseHasError(payload)) {
        return state;
      }

      /*
       * We only need to return the array we get from the backend in this case
       * as it will always be the current state of the intelligence progress
       * for schools.
       */
      return payload.body;
    default:
      return state;
  }
}

export {
  schoolGeneralIntelligenceProgress,
  initialState
};

export default enableInitializing(schoolGeneralIntelligenceProgress);
